import { Component, OnInit } from '@angular/core';
import { colors, AuthorizationSchemeService, AuthorizationScheme, MgAutocompleteData, AutocompleteDataSourceFn, getConfirmation } from '@mango/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SoortService } from 'src/app/core/service/soort.service';
import { Soort } from 'src/app/core/dto/soort';
import { Merk } from 'src/app/core/dto/merk';
import { MerkService } from 'src/app/core/service/merk.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { MatDialog } from '@angular/material/dialog';
import { PrijscorrectieArtikelService } from './prijscorrectieArtikel.service';
import { ArtikelgroepService } from 'src/app/core/service/artikelgroep.service';
import { Artikelgroep } from 'src/app/core/dto/artikelgroep';

@Component({
    selector: 'prijscorrectieArtikel',
    templateUrl: './prijscorrectieArtikel.component.html',
    styleUrls: ['./prijscorrectieArtikel.component.css']
})
export class PrijscorrectieArtikelComponent {
    
    constructor(public dialog: MatDialog, private prijscorrectieArtikelService: PrijscorrectieArtikelService, private authService: AuthorizationSchemeService, private artikelGroepService: ArtikelgroepService, private fb: FormBuilder, private snackBar: MatSnackBar, private router: Router ) {
        this.myScheme = this.authService.getMyScheme();
    }

    myScheme: AuthorizationScheme;
    PrijscorrectieArtikelFormGroup: FormGroup;
    getArtikelGroepDataSource: AutocompleteDataSourceFn<Artikelgroep> = MgAutocompleteData.empty();

    ngOnInit() {

        if (!this.myScheme.canDo("CIJBorculo.Logic.PrijscorrectieArtikelRequest")) {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
                this.router.navigateByUrl('/dashboard'));
        }

        this.PrijscorrectieArtikelFormGroup = this.fb.group({
            alles: this.fb.control(false, null),
			artikelgroepID: this.fb.control(null, null),
            percentage: this.fb.control(null, null),
		});

        this.getArtikelGroepDataSource = MgAutocompleteData.complex<Artikelgroep>(this.artikelGroepService, null).text('groep').datasource();
    }
 
    async PrijscorrectieArtikel(){

        let ok = await getConfirmation(this.dialog, "Prijscorrectie", "Weet u zeker dat u de prijscorrectie uit wil voeren ?");

        if (ok)        
        {
            // Set values
            let { alles, artikelgroepID, percentage } = this.PrijscorrectieArtikelFormGroup.value;

            if (percentage == null || percentage == 0) {            
                this.snackBar.open(`Er is geen percentage ingevuld !`, 'ok', { duration: 100000 }); 
            } else {
                if (alles == false && artikelgroepID == null) {            
                    this.snackBar.open(`Er is geen selectie ingevuld !`, 'ok', { duration: 100000 }); 
                } else {
                this.prijscorrectieArtikelService.Prijscorrectie(alles, artikelgroepID, percentage).toPromise().then(
                        (value) => {
                            if (value.successful) {                        
                                this.snackBar.open("De prijscorrectie is doorgevoerd! " + value.message , 'ok', { duration: 100000 }); 
                                // Refresh page (om te voorkomen dat niet per ongeluk hetzelfde nog een keer wordt gedaan)
                                this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
                                this.router.navigateByUrl('/prijscorrectieArtikel'));
                            }
                        });                                
                    }
            } 
        }   
    }

  
}
